import SearchFilter from 'records/SearchFilter'

export const SEARCH_PRODUCT_CATALOG_FILTER_MAINTAIN = 'SEARCH_PRODUCT_CATALOG_FILTER_MAINTAIN';
export const SEARCH_PRODUCT_CATALOG_FILTER_RESET_STATE = 'SEARCH_PRODUCT_CATALOG_FILTER_RESET_STATE';

export function searchProductCatalogFilterMaintain(data) {
  return {
    type: SEARCH_PRODUCT_CATALOG_FILTER_MAINTAIN,
    data,
  };
}

export function searchProductCatalogFilterReset() {
  return {
    type: SEARCH_PRODUCT_CATALOG_FILTER_RESET_STATE,
  };
}

export function changeSearchProductCatalogFilter(itemType, itemValue, multiple) {
  return (dispatch, getState) => {
    let filterData = getState().searchProductCatalogFilter.get('data');
    let conditionsList = SearchFilter.updateSearchFilterItem(filterData, itemType, itemValue, multiple);
    dispatch(searchProductCatalogFilterMaintain(conditionsList));
    return conditionsList;
  };
}
